import classNames from 'classnames';
import { ModuleArrLoad } from 'layout/module-load/module-load-arr.js';
import { ModulesLazyLoadWrapper } from 'layout/module-load/modules-lazy-load-wrapper.js';
import { getModulesMetaData } from 'layout/module-load/modules-meta-data.js';
import { IPrimarySlotPropsMap } from 'redux-state/layout/types.layout.js';
import { IColumnLayout } from 'redux-state/layout/types.modules.js';
import { ModulePath } from 'utilities/modulePath/modulePath.js';
import { StickyLayoutPrimarySlots } from 'utilities/sticky/stickySlots.js';
import { getMainWidthConfig, hasModules } from './five-up-utils.js';
import { RenderSideModule } from './sideModule.js';

export const RenderLargeLayout = ({
  filteredPrimaryConfig,
  columnLayout,
}: {
  filteredPrimaryConfig: IPrimarySlotPropsMap;
  columnLayout: IColumnLayout;
}) => {
  const { leftMajor, leftMinor, rightMajor, rightMinor, main } = filteredPrimaryConfig;
  const hasLeftMajor = hasModules(leftMajor);
  const hasLeftMinor = hasModules(leftMinor);
  const hasLeftSlot = hasModules(leftMajor) || hasModules(leftMinor);
  const hasRightSlot = hasModules(rightMajor) || hasModules(rightMinor);
  const hasMain = hasModules(main);
  return (
    <>
      {hasLeftSlot && (
        <div className="Grid-cell u-lg-width1of3 u-xl-width3of12 left-sidebar">
          {hasLeftMajor && (
            <ModulesLazyLoadWrapper
              section={getModulesMetaData('five-up-lg-leftMajor', leftMajor.modules)}
              className="u-mB-responsive"
            >
              <ModuleArrLoad modules={leftMajor.modules} modulePath={ModulePath.PRIMARY_LEFT_MAJOR} />
            </ModulesLazyLoadWrapper>
          )}
          {hasLeftMinor && (
            <ModulesLazyLoadWrapper
              section={getModulesMetaData('five-up-lg-leftMinor', leftMinor.modules)}
              className="u-mB-responsive"
            >
              <ModuleArrLoad modules={leftMinor.modules} modulePath={ModulePath.PRIMARY_LEFT_MINOR} />
            </ModulesLazyLoadWrapper>
          )}
        </div>
      )}

      {hasMain && (
        <div className={classNames('Grid-cell', `${getMainWidthConfig(hasLeftSlot, hasRightSlot)}`)}>
          {hasModules(main) && (
            <ModulesLazyLoadWrapper section={getModulesMetaData('five-up-lg-main', main.modules)}>
              <ModuleArrLoad modules={main.modules} modulePath={ModulePath.PRIMARY_MAIN} />
            </ModulesLazyLoadWrapper>
          )}
          {hasRightSlot && columnLayout === '2-column' && (
            <div className={`Grid-cell u-xl-mT-0 u-xl-width3of12 u-xl-inlineBlock u-mT-responsive`}>
              <RenderSideModule rightMajor={rightMajor} rightMinor={rightMinor} />
            </div>
          )}
        </div>
      )}

      {hasRightSlot && columnLayout === '3-column' && (
        <StickyLayoutPrimarySlots
          isSticky={false}
          offset={1}
          classes={`Grid-cell u-xl-mT-0 u-xl-width3of12 u-xl-inlineBlock`}
        >
          <RenderSideModule rightMajor={rightMajor} rightMinor={rightMinor} />
        </StickyLayoutPrimarySlots>
      )}
    </>
  );
};
